import React from "react";
import { Plus } from "lucide-react";
import { money2 } from "../payrollHelpers";

const EARNING_ROWS = [
  { key: "regularPay", cat: "TIME", label: "Hourly / Regular" },
  { key: "commission", cat: "COMMISSION", label: "Commission" },
  { key: "salaryPay", cat: "SALARY", label: "Salary" },
  { key: "bonus", cat: "BONUS", label: "Bonus" },
  { key: "flatPay", cat: "PIECE_RATE", label: "Piece Rate" },
];
const MANUAL_ONLY = [
  { cat: "SPIFF", label: "Spiff" },
  { cat: "HOLIDAY", label: "Holiday Pay" },
  { cat: "PTO", label: "PTO" },
  { cat: "SICK", label: "Sick Pay" },
  { cat: "OTHER_EARNING", label: "Other Earning" },
];

export default function EarningsTab({ row, adjustments, canPayroll, onAddEarning, onAddSpiff, onAddHoliday }) {
  const sumCat = (cat) => (adjustments || []).filter((a) => a.category === cat).reduce((s, a) => s + a.adjustmentAmount, 0);
  const canAdd = canPayroll("add_adjustments") || canPayroll("edit_bonuses") || canPayroll("edit_hours") || canPayroll("edit_commissions");

  return (
    <div data-testid="payroll-earnings-tab">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10.5px] font-bold uppercase tracking-wider text-slate-400">Earnings</div>
        {canAdd && (
          <div className="flex items-center gap-1.5">
            <button onClick={() => onAddSpiff({ employeeId: row.tech.id })} data-testid="payroll-add-spiff-btn"
              className="h-7 px-2.5 rounded-md border border-slate-200 hover:bg-slate-50 text-slate-700 text-[11.5px] font-semibold flex items-center gap-1">
              <Plus className="h-3 w-3" /> Spiff
            </button>
            <button onClick={() => onAddHoliday({ employeeId: row.tech.id })} data-testid="payroll-add-holiday-btn"
              className="h-7 px-2.5 rounded-md border border-slate-200 hover:bg-slate-50 text-slate-700 text-[11.5px] font-semibold flex items-center gap-1">
              <Plus className="h-3 w-3" /> Holiday Pay
            </button>
            <button onClick={() => onAddEarning({ employeeId: row.tech.id })} data-testid="payroll-add-earning-btn"
              className="h-7 px-2.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-[11.5px] font-semibold flex items-center gap-1">
              <Plus className="h-3 w-3" /> Add Earning
            </button>
          </div>
        )}
      </div>
      <div className="grid grid-cols-4 gap-2 pb-2 text-[10.5px] font-bold uppercase tracking-wider text-slate-400">
        <div>Type</div><div>System</div><div>Adjustment</div><div>Final</div>
      </div>
      {EARNING_ROWS.map((e) => {
        const sys = row[e.key] || 0;
        const adj = e.cat === "TIME" ? 0 : sumCat(e.cat); // TIME's pay impact is derived in the Summary tab
        const final = sys + adj;
        if (!sys && !adj) return null;
        return (
          <div key={e.key} className="grid grid-cols-4 gap-2 py-2 border-b border-slate-100 text-[13px]" data-testid={`earning-row-${e.cat}`}>
            <div className="font-medium text-slate-800">{e.label}</div>
            <div className="text-slate-500">{money2(sys)}</div>
            <div className={adj ? (adj > 0 ? "text-emerald-600" : "text-rose-600") : "text-slate-400"}>{adj ? money2(adj) : "—"}</div>
            <div className="font-bold text-slate-900">{money2(final)}</div>
          </div>
        );
      })}
      {MANUAL_ONLY.map((m) => {
        const adj = sumCat(m.cat);
        if (!adj) return null;
        return (
          <div key={m.cat} className="grid grid-cols-4 gap-2 py-2 border-b border-slate-100 text-[13px]" data-testid={`earning-row-${m.cat}`}>
            <div className="font-medium text-slate-800">{m.label}</div>
            <div className="text-slate-400">$0.00</div>
            <div className={adj > 0 ? "text-emerald-600" : "text-rose-600"}>{money2(adj)}</div>
            <div className="font-bold text-slate-900">{money2(adj)}</div>
          </div>
        );
      })}
    </div>
  );
}
